import { getMoonPhase } from '../data/moon';
import { getCosmicThreatLevel } from '../data/astrology';

/**
 * Renders the Cosmic weather panel into the given container.
 */
export function renderCosmicWeatherCard(container: HTMLElement): void {
  const now = new Date();
  const phase = getMoonPhase(now);
  const cosmic = getCosmicThreatLevel(now, phase.name);

  const panel = document.createElement('div');
  panel.className = 'panel';
  panel.innerHTML = `
    <div class="threat-header">
      <span class="threat-title">Cosmic weather</span>
      <span class="threat-emoji" aria-hidden="true">✨</span>
    </div>
    <p class="panel-content threat-subtext">Daily intensity from the tropical moon sign and lunar phase, computed locally from the date — not NOAA space weather or a forecast.</p>
    <div class="threat-label-row">
      <span>Intensity</span>
      <strong>Level ${cosmic.level}/5 — ${cosmic.label}</strong>
    </div>
    <div class="threat-meter" aria-hidden="true">
      <div class="threat-meter-fill level-${cosmic.level}"></div>
    </div>
  `;
  container.appendChild(panel);
}
